import React, { useState } from 'react';
import { Descriptions, Modal } from 'antd';
import styled from 'styled-components';

import { DARK_MODAL_CLASS } from 'components/theme/DarkPageScope/constants';
import API from 'utils/request';

import { getCardType } from '../filters/filterOptions';
import { ICustomerCard } from './BDOCustomerCard';

interface ICardModalProps {
  open: boolean;
  cardProps: ICustomerCard['cardProps'];
  closeModal: () => void;
  onCancel: () => void;
  refetchCustomer: () => void;
}

const ReplaceCardModal = ({
  open,
  cardProps,
  closeModal,
  onCancel,
  refetchCustomer
}: ICardModalProps) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  return (
    <StyledModal
      wrapClassName={DARK_MODAL_CLASS}
      open={open}
      title="Replace card?"
      bodyStyle={{ padding: '30px 38px' }}
      confirmLoading={confirmLoading}
      okButtonProps={{
        style: { backgroundColor: 'red', border: 'transparent', fontWeight: '600' }
      }}
      okText="Replace card"
      onOk={async () => {
        setConfirmLoading(true);
        try {
          await API.patch(
            `/v4/dash/custom/bdo/card_status/${cardProps.brc}`,
            {
              card: {
                'Card Status': 'B',
                'Card Type': cardProps.tier,
                'Activity Description': 'Card Replacement',
                Remarks: 'For Replacement'
              }
            },
            { headers: { 'Content-Type': 'application/json' } }
          );
          setConfirmLoading(false);
          closeModal();
          Modal.success({
            title: 'Card successfully replaced',
            content: (
              <div>
                <p>BRC {cardProps.brc} has been successfully replaced.</p>
              </div>
            ),
            onOk() {
              refetchCustomer();
            }
          });
        } catch (e) {
          const errorMsg = e?.response?.data?.message;
          setConfirmLoading(false);
          closeModal();
          Modal.error({
            title: 'Card replacement failed',
            content: <div>{errorMsg && <p>{errorMsg}</p>}</div>
          });
        }
      }}
      onCancel={onCancel}
    >
      <Descriptions column={{ sm: 1 }} colon={false} layout="horizontal" title="">
        <Descriptions.Item key="brc" label="BRC">
          <strong>{cardProps?.brc}</strong>
        </Descriptions.Item>
        <Descriptions.Item key="tier" label="Tier">
          <strong>{getCardType(cardProps?.tier)?.label}</strong>
        </Descriptions.Item>
        <Descriptions.Item key="seq" label="Seq">
          <strong>{cardProps?.sequence}</strong>
        </Descriptions.Item>
      </Descriptions>
      Are you sure you want to replace this card?
      <br />
      {getCardType(cardProps?.tier)?.label === 'Emerald' && (
        <strong>Replacement fee of 150 points will be deducted.</strong>
      )}
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-header {
    background-color: red;
    color: white;
  }

  .ant-modal-title {
    color: white;
    font-weight: 600;
  }

  .ant-modal-close-x {
    color: white;
  }
`;

export default ReplaceCardModal;
